import { render, staticRenderFns } from "./food-illustrate.vue?vue&type=template&id=2597a66c&scoped=true&"
import script from "./food-illustrate.vue?vue&type=script&lang=js&"
export * from "./food-illustrate.vue?vue&type=script&lang=js&"
import style0 from "./food-illustrate.vue?vue&type=style&index=0&id=2597a66c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2597a66c",
  null
  
)

export default component.exports